module.exports = __webpack_public_path__ + "static/pattern1-d25bf4205a13e88dbdc27161d26c4082.jpg";